import { openDB } from 'idb'

const create = openDB('tendero.v4', 1, {
  upgrade(db) {
    db.createObjectStore('products', { autoIncrement: true })
    db.createObjectStore('combos', { autoIncrement: true })
    db.createObjectStore('clients', { autoIncrement: true })
    db.createObjectStore('paymentMethods', { autoIncrement: true })
    db.createObjectStore('sells', { autoIncrement: true })
    db.createObjectStore('turn', { autoIncrement: true })
    db.createObjectStore('auth', { autoIncrement: true })
  },
})

const add = (data, store) => {
  return create.then(db => {
    if (!data || !data[0]) return

    return db.clear(store).then(() => {
      const tx = db.transaction(store, 'readwrite')
      return Promise.all(data.map(d => tx.store.add(d)))
    })
  })
}

const addOne = (data, store) => {
  return create.then(db => db.add(store, data))
}

const getAll = store => {
  return create.then(db => db.getAll(store))
}

const deleteAll = store => {
  return create.then(db => db.clear(store))
}

export default {
  add,
  addOne,
  getAll,
  deleteAll,
}
